<template>
    <v-app-bar app class="toolbar transparent" flat absolute>
        <v-app-bar-nav-icon
                v-if="this.$store.state.user"
                @click.stop="$emit('navigationDrawerClicked')"
        />

        <v-toolbar-title style="cursor: pointer;"
                         @click="$router.push({name: 'home'})">Gloomhaven Camp Track
        </v-toolbar-title>

        <v-spacer/>

        <template v-for="item in userItems">
            <v-btn
                    class="nav-btn"
                    active-class="clicked"
                    tile
                    x-large
                    text
                    v-ripple="false"
                    :to="item.path"
                    :key="item.title"
                    v-if="$store.state.user"
            >{{ item.title }}
            </v-btn>
        </template>

        <!-- Hide this button when on Auth.vue or SignUp.vue -->
        <v-btn
                class="nav-btn black--text text-uppercase"
                large
                color="white"
                @click="$router.push({name: 'auth'})"
                v-if="!$store.state.user && $route.name !== 'auth'"
        >Sign in
        </v-btn>
    </v-app-bar>
</template>

<script>
  export default {
    data: () => ({
      drawer: false,
      userItems: []
    }),
  };
</script>
